import { Grid } from '@mui/material';
import { SidebarHeader } from '@pages/QuoteDetails/sidebarItems/SidebarHeader';
import {
  SubjectivitiesItem,
  SubjectivityItem,
} from '@pages/QuoteDetails/sidebarItems/subjectivities/SubjectivitiesItem';
import { useStore } from '@store/GlobalStore';
import { shallow } from 'zustand/shallow';

type SubjectivitiesPanelProps = {
  data: SubjectivityItem[];
  changeTab: (newTab: SubjectivitiesTab) => void;
  selectItem: (newItem?: SubjectivityItem) => void;
};

export enum SubjectivitiesTab {
  Subjectivities = 'Subjectivities',
  EditSubjectivity = 'EditSubjectivity',
  NewSubjectivity = 'NewSubjectivity',
}

export const SubjectivitiesPanel = ({ data, changeTab, selectItem }: SubjectivitiesPanelProps) => {
  const { isUnderwriter, isLIOContractor, isBroker } = useStore((state) => state.userAuth, shallow);
  const activeSubjectivities = data?.filter((el) => el.status === 'Active');
  const closedSubjectivities = data?.filter((el) => el.status !== 'Active');

  return (
    <Grid
      sx={{
        flexGrow: 3,
        overflow: 'overlay',
        '::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      {activeSubjectivities?.length ? (
        <>
          <SidebarHeader title='Open Subjectivities' />
          {activeSubjectivities.map((el) => (
            <SubjectivitiesItem
              key={el.id}
              isBroker={isBroker}
              item={el}
              onClick={
                isUnderwriter || isLIOContractor || (isBroker && el.isBrokerSubjectivity)
                  ? () => {
                      selectItem(el);
                      changeTab(SubjectivitiesTab.EditSubjectivity);
                    }
                  : undefined
              }
            />
          ))}
        </>
      ) : null}
      {closedSubjectivities?.length ? (
        <>
          <SidebarHeader title='Closed Subjectivities' />
          {closedSubjectivities.map((el) => (
            <SubjectivitiesItem
              key={el.id}
              item={el}
              isBroker={isBroker}
              onClick={
                isUnderwriter || isLIOContractor
                  ? () => {
                      selectItem(el);
                      changeTab(SubjectivitiesTab.EditSubjectivity);
                    }
                  : undefined
              }
            />
          ))}
        </>
      ) : null}
    </Grid>
  );
};
